export default "__VITE_ASSET__84e0a7f2__"